<template>  
    <router-view/>    
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems';
import types from '@/store/all-mutation-types'

  
@Component({
  name: 'Smart', 
})
export default class Smart extends Vue {      
  // BLF037 — droit du rôle, puis module Smart Planning accessible (RG-ACC-051) ; un rôle
  // multi-enseignes attend la liste des enseignes avant de décider. (L'ancien garde rappelait
  // `next` dans le rappel de `next` et ne redirigeait pas.)
  beforeRouteEnter(to:any,from:any,next:any) {
    next((vm:Smart) => {
      const store = vm.$store
      const check = () => {
        if (!store.myGetters.userSecurity[SecurityItemsKeys.HOME_SMART_PLANNING].enable) vm.$router.replace('/login')
        else if (!store.myGetters.hasSmartPlanningModule) vm.$router.replace('/')
      }
      if (store.myGetters.isMultiTenantRole) store.dispatch(types.ENSEIGNE_ENSURE_LIST).catch(() => {}).finally(check)
      else check()
    })
  }

  mounted(){
    this.$vuetify.theme.primary = '#FB8C00'
    this.$vuetify.theme.secondary = '#4066aa'    
  }
}
</script> 